import { AxiosPromise } from 'axios';
import Http from '../../shared/http';

const http = Http.getHttp();

export default function exportCases(
  id: number,
  body: string
): AxiosPromise<BlobPart> {
  return http.post(`/cases/${id}/export?${body}&$view=reporting`, {
    responseType: 'blob'
  });
}
